import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../styles/layout.css";

export default function NavBar() {
	const { isAuthenticated, logout } = useAuth();
	const navigate = useNavigate();
	return (
		<nav className="navbar navbar--main">
			<div className="nav-items-wrapper">
				<div className="nav-links">
					<NavLink to="/" className={({ isActive }) => `nav-link${isActive ? " active" : ""}`} end>
						HOME
					</NavLink>
					<NavLink
						to="/festivalaki"
						className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
					>
						FESTIVALAKI
					</NavLink>
					<NavLink to="/contact" className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
						CONTACT
					</NavLink>
					{isAuthenticated && (
						<NavLink
							to="/registrations"
							className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
						>
							REGISTRATIONS
						</NavLink>
					)}
				</div>
				<div className="nav-auth-actions">
					{isAuthenticated ? (
						<button
							onClick={() => {
								logout();
								navigate("/login");
							}}
							className="btn-logout"
						>
							Logout
						</button>
					) : (
						<NavLink to="/login" className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
							Login
						</NavLink>
					)}
				</div>
			</div>
		</nav>
	);
}
